import { useCallback } from 'react';
import { useToastContext } from './toast-context';
import { ToastOptions } from './types';

export function useToast() {
  const { addToast, removeToast, removeAll } = useToastContext();

  const toast = useCallback(
    (options: ToastOptions) => {
      const id = addToast(options);

      if (options.duration !== 0) {
        setTimeout(() => {
          removeToast(id);
        }, options.duration || 5000);
      }

      return id;
    },
    [addToast, removeToast]
  );

  const success = useCallback(
    (options: Omit<ToastOptions, 'variant'>) => toast({ ...options, variant: 'success' }),
    [toast]
  );

  const error = useCallback(
    (options: Omit<ToastOptions, 'variant'>) => toast({ ...options, variant: 'error' }),
    [toast]
  );

  const warning = useCallback(
    (options: Omit<ToastOptions, 'variant'>) => toast({ ...options, variant: 'warning' }),
    [toast]
  );

  const info = useCallback(
    (options: Omit<ToastOptions, 'variant'>) => toast({ ...options, variant: 'info' }),
    [toast]
  );

  return {
    toast,
    success,
    error,
    warning,
    info,
    dismiss: removeToast,
    dismissAll: removeAll,
  };
}
